import { Navigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

export default function ProtectedRoute({ children }) {
  const token = sessionStorage.getItem("token");
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("user"));

  // If no token, redirect to login
  if (!token && location.pathname !== "/whats-app-authentication") {
    return <Navigate to="/whats-app-authentication" replace />;
  }

  // ✅ VENDOR: subscription validation
  if (user && user.role === "vendor") {
    const subscription = user.vendorDetails?.subscription;

    if (subscription) {
      const { plan, status, endDate } = subscription;

      // 1️⃣ Expiry check
      if (endDate) {
        const currentDate = new Date();
        const expiryDate = new Date(endDate);

        if (expiryDate < currentDate) {
          toast.warning("Your subscription has expired. Please renew your plan.");
          sessionStorage.clear();
          localStorage.clear();
          return <Navigate to="/whats-app-authentication" replace />;
        }
      }

      // 2️⃣ Restrict free plan access
      if (
        plan === "free" &&
        !location.pathname.includes("/subscription")
      ) {
        toast.warning("Upgrade your plan to access this page.");
        return <Navigate to="/subscription" replace />;
      }

      // 3️⃣ Handle inactive or cancelled plans
      if (status === "expired" || status === "cancelled") {
        toast.warning("Your plan is inactive. Please renew your subscription.");
        sessionStorage.clear();
        localStorage.clear();
        return <Navigate to="/whats-app-authentication" replace />;
      }
    }
  }

  // ✅ EMPLOYEE: permission-based access
  if (user && user.role === "employee") {
    const { permissions } = user;

    // Check if trying to access product management routes
    const isProductRoute = location.pathname.includes("/product-management");

    if (isProductRoute) {
      const hasAnyPermission =
        permissions?.canAddProduct ||
        permissions?.canAddService ||
        permissions?.canAddCombo;

      if (!hasAnyPermission) {
        toast.error("You don't have permission to access product management.");
        return <Navigate to="/" replace />;
      }
    }
  }

  // ✅ Everything fine → render children
  return children;
}
